import { useQuery } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchInvoiceNumberingSequences } from '../query-api'

export const useInvoiceNumberingSequences = () => {
  const { data: invoiceNumberingSequencesData, ...rest } = useQuery(QueryKeys.ExternalInvoiceNumberingSequences, () =>
    fetchInvoiceNumberingSequences(),
  )

  return { invoiceNumberingSequences: invoiceNumberingSequencesData?.data || [], ...rest }
}
